import ImagesLogoHillebrandVEPng from '@/public/images/logo-hillebrand-VE.png';
import ImagesNoImagePlaceholderPng from '@/public/images/no-image-placeholder.png';
import ImagesNoImagePlaceholderSvg from '@/public/images/No-Image-Placeholder.svg';
import ImagesOnlyLogoWebp from '@/public/images/onlyLogo.webp';
import ImagesSampleWhiskyJpg from '@/public/images/sample_whisky.jpg';

export {
  ImagesLogoHillebrandVEPng,
  ImagesNoImagePlaceholderPng,
  ImagesNoImagePlaceholderSvg,
  ImagesOnlyLogoWebp,
  ImagesSampleWhiskyJpg,
};
